export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    //scrolls to content if the page is NOT home or contact
    if(!$('body').hasClass('home') && !$('body').hasClass('contact-us')){
      //scrolls to #maincontent
      $('html, body').animate({
        scrollTop: $('.main').offset().top - 300,
        }, 1000);
    }

    //open modal on click (// NOTE: remember to click unbind JS event in the megamenu > general settings )
    $('.launch-contactmodal a, .mega-launch-contactmodal a').click(function(e){
      e.preventDefault();
      $('#contactModal').modal('show');
    });


    //open modal on click (// NOTE: remember to click unbind JS event in the megamenu > general settings )
    $('.launch-callbackmodal a, .mega-launch-callbackmodal a').click(function(e){
      e.preventDefault();
      $('#callBackModal').modal('show');
    });

    //Testimonial carousel in footer
    $('.tesimonials-carousel').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      autoplay: true,
      autoplaySpeed: 5000,
      dots: true,
      arrows:false,
    });

    //carousel in footer
    $('.footer-accreditations').slick({
      infinite: true,
      lazyLoad: 'ondemand',
      centerMode: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      swipeToSlide: true,
      autoplay: true,
      autoplaySpeed: 3000,
      dots: false,
      arrows:false,
      responsive: [{
          breakpoint: 1200, //xl
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        }, {
        breakpoint: 992, //lg
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      }, {
        breakpoint: 768, //md
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      }, {
        breakpoint: 576, //sm
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      }, {
        breakpoint: 450, //xs-ish
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      }],
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js